//
// Login:
//

export const index = {
    path   : '/recruit_sources/',
    method : 'GET',
    version: '/v1'
}

export const getItem = {
  path   : '/recruit_sources/:recruit_sources_id/',
  method : 'GET',
  version: '/v1'
}

export const addItem = {
  path   : '/recruit_sources/',
  method : 'POST',
  version: '/v1'
}

export const updateItem = {
  path   : '/recruit_sources/:recruit_sources_id/',
  method : 'POST',
  version: '/v1'
}

export const deleteItem = {
  path   : '/recruit_sources/:recruit_sources_id/',
  method : 'DELETE',
  version: '/v1'
}
